<template>
    <div class="card shadow-sm mb-4">
        <div class="card-header text-white bg-secondary fw-bold">Completed Scorecards</div>
        <div class="card-content p-2">
            <div v-if="!visit_loading">
                <span v-if="Object.keys(props.completed_scorecards).length">
                    <div v-for="visit_observer in props.completed_scorecards" v-bind:key="visit_observer.id" class="col-12" @click="router.push({name:'visit',params:{visit_id:visit_observer.visit_id}})">
                        <div class="row visit-card">
                            <div class="col-10">
                                <img :src="visit_observer.visit.scenario.patient_image.location" class="rounded-circle float-start me-2" width="75" />
                                <div class="border-end time-slot float-start pt-3 me-2">
                                    <span class="text-secondary fw-bold">{{ moment(visit_observer.visit.utc_time || visit_observer.visit.local_time).format('MM/DD/YY') }}</span>
                                    <hr class="my-1">
                                    <span class="text-primary fw-bold">{{ moment(visit_observer.visit.utc_time || visit_observer.visit.local_time).format('h:mm') }}<sup>{{ moment(visit_observer.visit.utc_time || visit_observer.visit.local_time).format('a') }}</sup></span>
                                </div>
                                <div class="mobile-visit-card">
                                    <div class="fw-bold text-secondary">{{visit_observer.visit.scenario.patient_name}}</div>
                                    <div class="overflow-hidden">{{visit_observer.visit.scenario.title}}</div>
                                </div>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center">
                                <h3 class="text-center"><i class='fas fa-clipboard-check text-primary'></i></h3>
                            </div>
                        </div>
                        <hr class="w-75" />
                    </div>
                    <lazy-pagination v-if="props.completed_scorecards_total > 10" :items="props.completed_scorecards" :total="props.completed_scorecards_total" :page_start="page_start" :page_end="page_end" v-on:next-page="nextPage" v-on:previous-page="previousPage" :label="'Scorecards'" />
                </span>
                <p v-else class="text-center pt-3">No Completed Scorecards</p>
            </div>
            <div class="loading-card-area" v-else>
                <loading :active="visit_loading" :is-full-page="false"></loading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {defineComponent,ref} from "vue";
    import Loading from 'vue3-loading-overlay';
    import moment from 'moment';
    import LazyPagination from '@/components/dashboard/lazy-pagination.vue';
    import router from "@/router";

    export default defineComponent({
        emits: ['change-page'],
        components: {
            Loading,
            LazyPagination
        },
        props: {
            completed_scorecards: {type:Object, required:true},
            completed_scorecards_total: {type:Number, required:true},
            visit_loading: {type:Boolean, required:true}
        },
        setup(props, {emit}) {
            const page_start = ref(0);
            const page_end = ref(10);
            const nextPage = async() => {
                page_start.value = page_start.value + 10;
                page_end.value = page_end.value + 10;
                if(page_end.value > props.completed_scorecards_total){
                    page_end.value = props.completed_scorecards_total;
                }
                emit('change-page',{type:'completed','page_start':page_start.value});
            };
            const previousPage = async() => {
                page_start.value = page_start.value - 10;
                page_end.value = page_start.value + 10;
                emit('change-page',{type:'completed','page_start':page_start.value});
            };
            return {
                moment,
                nextPage,
                page_end,
                page_start,
                previousPage,
                props,
                router
            };
        }
    });
</script>
